import { ModalController } from '@ionic/angular';
import { ModalOptions } from '@ionic/core';
import { Injectable, TemplateRef } from '@angular/core';

import { ThemeService } from '../page-layout/theme.service';
import { ModalComponent } from './modal.component';

@Injectable()
export class Modal {
    // Constructor injection rather than inject(): this service is also constructed
    // directly in its own spec, where a field-level inject() would run outside an
    // injection context and throw.
    constructor(
        private modalController: ModalController,
        private themeService: ThemeService
    ) {}

    async show(config: ModalConfig) {
        // `<game-theme> no-background` is what .github/instructions/modals.instructions.md
        // requires of every modal, so it is the default rather than something each caller
        // has to remember -- most did not, which is why modals across the events section
        // rendered unthemed. An explicit cssClass still wins.
        const props = {
            ...config.props,
            cssClass: config.props?.cssClass ?? `${this.themeService.theme()} no-background`
        };

        const modal = await this.modalController.create({
            component: config.component || ModalComponent,
            backdropDismiss: true,
            showBackdrop: true,
            componentProps: props
        });

        return modal.present();
    }

    async dismiss() {
        return this.modalController.dismiss();
    }
}

export type ModalConfig = Partial<Pick<ModalOptions, 'component'>> & {
    beforeDismiss?: Function;
    afterDismiss?: Function;
    props?: {
        contentTemplate?: TemplateRef<any>;
        buttonsTemplate?: TemplateRef<any>;
        cssClass?: string;
        title?: string;
        data?: any;
        buttonsDirection?: 'vertical' | 'horizontal';
        [propName: string]: any;
    };
};
